// frontend/src/components/Groups/GroupsHome.js
import React from 'react';
import { Link } from 'react-router-dom';

function GroupsHome() {
    return (
        <div className="container">
            <h1>Groups Management</h1>
            <p>Organize and manage student groups across core classes, CTE programs, and homeroom assignments.</p>
            
            <div className="groups-actions">
                <h2>Group Management Tools</h2>
                <div className="action-grid">
                    <Link to="/groups/add" className="action-card">
                        <h3>➕ Add New Group</h3>
                        <p>Create new student groups for classes and programs</p>
                    </Link>
                    
                    <Link to="/groups/manage" className="action-card">
                        <h3>📚 Manage Core Groups</h3>
                        <p>Organize core academic subject groups and assignments</p>
                    </Link>
                    
                    <Link to="/groups/manage-cte" className="action-card">
                        <h3>🔧 Manage CTE Groups</h3>
                        <p>Handle Career and Technical Education program groups</p>
                    </Link>
                    
                    <Link to="/groups/homeroom" className="action-card">
                        <h3>🏠 Homeroom Management</h3>
                        <p>Manage homeroom assignments and student rosters</p>
                    </Link>
                    
                    <Link to="/groups/reports" className="action-card">
                        <h3>📈 Group Reports</h3>
                        <p>View group statistics and membership reports</p>
                    </Link>
                    
                    <Link to="/groups/bulk-actions" className="action-card">
                        <h3>⚙️ Bulk Operations</h3>
                        <p>Perform bulk student assignments and transfers</p>
                    </Link>
                </div>
            </div>
            
            <style jsx>{`
                .container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 20px;
                }
                
                .action-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
                    gap: 20px;
                    margin-top: 20px;
                }
                
                .action-card {
                    display: block;
                    padding: 24px;
                    border: 1px solid #e0e0e0;
                    border-radius: 12px;
                    text-decoration: none;
                    color: inherit;
                    transition: all 0.3s ease;
                    background: #ffffff;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.05);
                }
                
                .action-card:hover {
                    border-color: #1976d2;
                    box-shadow: 0 4px 12px rgba(25,118,210,0.15);
                    transform: translateY(-3px);
                }
                
                .action-card h3 {
                    margin: 0 0 12px 0;
                    color: #1976d2;
                    font-size: 1.2rem;
                    font-weight: 600;
                }
                
                .action-card p {
                    margin: 0;
                    color: #666;
                    line-height: 1.5;
                }
                
                .groups-actions h2 {
                    color: #333;
                    margin-bottom: 10px;
                    font-size: 1.5rem;
                }
                
                h1 {
                    color: #1976d2;
                    margin-bottom: 10px;
                }
                
                p {
                    color: #666;
                    margin-bottom: 30px;
                    font-size: 1.1rem;
                }
            `}</style>
        </div>
    );
}

export default GroupsHome;
